export default {
  ref: null,
  set stickNavRef(ref) {
    this.ref = ref;
  },
  setStickyNavRef(ref) {
    this.stickNavRef = ref;
  },
  get stickyNavRef() {
    return this.ref;
  },
  getStickyNavRef() {
    return this.ref;
  },
  findPos(targetRef) {
    const stickyNavHeight = this.stickyNavRef?.current?.offsetHeight;
    if (targetRef.current && window) {
      let nodeHeight = targetRef?.current?.getBoundingClientRect().top + window.scrollY;
      return nodeHeight - stickyNavHeight;
    }
    return 0;
  },
  getAnalyticsTarget: (hash) => {
    switch (hash) {
    case 'product-overview':
      return 'Product Overview';
    case 'specifications':
      return 'Specifications';
    case 'questions_answers_full':
      return 'Questions & Answers';
    case 'ratings-and-reviews':
      return 'Customer Reviews';
    default:
      return null;
    }
  }
};
